import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CarbonPage = lazy(() => import('../pages/carbon/page'));
const BuildsPage = lazy(() => import('../pages/builds/page'));
const AtelierPage = lazy(() => import('../pages/atelier/page'));
const PerformancePage = lazy(() => import('../pages/performance/page'));
const ProcessPage = lazy(() => import('../pages/process/page'));
const ModelsPage = lazy(() => import('../pages/models/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const RequestPage = lazy(() => import('../pages/request/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/carbon',
    element: <CarbonPage />,
  },
  {
    path: '/builds',
    element: <BuildsPage />,
  },
  {
    path: '/atelier',
    element: <AtelierPage />,
  },
  {
    path: '/performance',
    element: <PerformancePage />,
  },
  {
    path: '/process',
    element: <ProcessPage />,
  },
  {
    path: '/models',
    element: <ModelsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/request',
    element: <RequestPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/cookies',
    element: <CookiesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
